import {
  Alert,
  Box,
  Button,
  CardMedia,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInUser, resetPassword } from "../firebase";
import { isLoggedIn } from "../session";
import logoSvg from "../imgs/logo192.png";

export default function Login() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();

    // validate the inputs
    if (!email || !password) {
      setError("Por favor ingrese su usuario y contraseña.");
      return;
    }

    // clear the errors
    setError("");

    // TODO: send the login request
    console.log("Iniciando sesión...");
    try {
      let loginResponse = await signInUser(email, password);
      isLoggedIn(loginResponse.user);
      navigate("/home");
    } catch (error) {
      console.error(error.message);
      setError(error.message);
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      setError("Por favor ingrese su dirección de correo electrónico.");
      return;
    }

    try {
      await resetPassword(email);
      setError(""); // Clear any previous errors
      alert("Email de restablecimiento de contraseña enviado con éxito.");
      // Optionally, you can provide a user-friendly message here.
    } catch (error) {
      console.error(error.message);
      setError(error.message);
    }
  };

  const tfSx = {
    mb: 0.5,
    "& .MuiOutlinedInput-root": {
      borderRadius: "14px",
      background: "rgba(255,255,255,0.05)",
      "& fieldset": { borderColor: "rgba(255,255,255,0.1)" },
      "&:hover fieldset": { borderColor: "rgba(0,212,255,0.35)" },
      "&.Mui-focused fieldset": { borderColor: "#00d4ff", borderWidth: "1px" },
    },
    "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.4)" },
    "& .MuiInputLabel-root.Mui-focused": { color: "#00d4ff" },
    "& .MuiInputBase-input": { color: "#fff" },
  };

  return (
    <Box sx={{ minHeight: "100vh", background: "#080b14", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px", position: "relative", overflow: "hidden" }}>
      <Box sx={{ position: "absolute", width: "600px", height: "600px", borderRadius: "50%", background: "radial-gradient(circle, rgba(0,212,255,0.09) 0%, transparent 70%)", top: "-200px", right: "-200px", pointerEvents: "none" }} />
      <Box sx={{ position: "absolute", width: "500px", height: "500px", borderRadius: "50%", background: "radial-gradient(circle, rgba(123,47,247,0.11) 0%, transparent 70%)", bottom: "-150px", left: "-200px", pointerEvents: "none" }} />
      <Box sx={{
        background: "rgba(255,255,255,0.03)",
        backdropFilter: "blur(32px)",
        WebkitBackdropFilter: "blur(32px)",
        borderRadius: "28px",
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 32px 64px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.07)",
        p: { xs: 3, sm: 5 },
        width: "100%",
        maxWidth: 400,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        zIndex: 1,
        animation: "fadeInUp 0.5s ease",
      }}>
        <Box sx={{ width: 72, height: 72, mb: 2, borderRadius: "20px", background: "linear-gradient(135deg, rgba(0,212,255,0.15), rgba(123,47,247,0.15))", border: "1px solid rgba(0,212,255,0.25)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 32px rgba(0,212,255,0.12)", overflow: "hidden" }}>
          <CardMedia component="img" image={logoSvg} alt="FindMe logo" sx={{ width: 52, height: 52, objectFit: "contain" }} />
        </Box>
        <Typography variant="h4" fontWeight={800} mb={0.5} sx={{ background: "linear-gradient(135deg, #00d4ff, #7b2ff7)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text", letterSpacing: "-0.5px" }}>
          FindMe
        </Typography>
        <Typography variant="body2" mb={3} sx={{ color: "rgba(255,255,255,0.35)" }}>
          Inicia sesión para continuar
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2, width: "100%", borderRadius: 2, bgcolor: "rgba(211,47,47,0.1)", border: "1px solid rgba(211,47,47,0.3)", color: "#ff6b7a" }}>{error}</Alert>
        )}
        <Box component="form" onSubmit={onSubmit} sx={{ width: "100%" }}>
          <TextField label="Correo electrónico" variant="outlined" fullWidth margin="normal" value={email} onChange={e => setEmail(e.target.value)} sx={tfSx} />
          <TextField label="Contraseña" type="password" variant="outlined" fullWidth margin="normal" value={password} onChange={e => setPassword(e.target.value)} sx={tfSx} />
          <Button type="submit" variant="contained" fullWidth sx={{ mt: 2, background: "linear-gradient(135deg, #00d4ff, #7b2ff7)", color: "#fff", borderRadius: "14px", fontWeight: 700, fontSize: "1rem", py: 1.5, textTransform: "none", letterSpacing: "0.3px", boxShadow: "0 8px 25px rgba(0,212,255,0.2)", "&:hover": { background: "linear-gradient(135deg, #00bfe8, #6a20d6)", boxShadow: "0 12px 35px rgba(0,212,255,0.35)", transform: "translateY(-2px)" }, transition: "all 0.2s ease" }}>
            Entrar
          </Button>
        </Box>
        <Button onClick={handleForgotPassword} sx={{ mt: 1.5, color: "rgba(0,212,255,0.6)", textTransform: "none", fontSize: "0.85rem", "&:hover": { color: "#00d4ff", background: "transparent" } }}>
          ¿Olvidaste tu contraseña?
        </Button>
        <Box sx={{ width: "100%", height: "1px", background: "rgba(255,255,255,0.06)", my: 2 }} />
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.35)" }}>
          ¿No tienes cuenta?{' '}
          <Link href="/register" sx={{ color: "#00d4ff", fontWeight: 600, textDecoration: "none", "&:hover": { opacity: 0.8 } }}>
            Regístrate
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}
